import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(utc);
dayjs.extend(customParseFormat);

export const getDateInUTC = (timestampEpoch: number, format = 'YYYY-MM-DD') => {
  let timestamp = timestampEpoch;
  if (timestampEpoch.toString().length === 13) {
    timestamp = timestampEpoch / 1000;
  }
  return dayjs.utc(dayjs.unix(timestamp)).format(format);
};

export default getDateInUTC;
